import $ from "jquery";
import Ext from "Ext";
import GenericSelectorPanel from "./at_generic_selector_panel";
import messageResource from "../../messageResource";
import {addClass, removeClass, isLetterOrDigitSymbolPressed, getArrayFromCookies, disableTextSelection, atImgPath} from "../../atBrowserUtils";
import TwoLevelSelection from "./two_level_selection";
import KeyDownHandler from "../../key_down_handler";
import FilterWordsField from "../FilterWordsField";
import FilterWordsPopup from "../filter_words_popup";
import SelectorFilter from "../../hierarchySelector/tree/SelectorFilter";
import IconButton from "../at_icon_button";

const HierarchicalSelectorPanel = Ext.extend(GenericSelectorPanel, {

    /**
     * @cfg {TreeRootNode} root node of nodes hierarchy
     */
    rootNode: null,
    /**
     * @cfg {StringIndex} index for words searching
     */
    searchIndex : null,
    /**
     * @cfg {TreeNodeSet} set of all active entities in selector
     */
    allActiveSet : null,

    hasPanel: true,

    collapsedCookiesKey: null,

    /**
     * fire "selectionChange" callback when "show inactive" checkbox changed
     */
    selectionChangedOnShowInactive:true,

    createComponents: function() {
        HierarchicalSelectorPanel.superclass.createComponents.call(this);

        this.createCustomControlButtons();

        var context = this;

        this.selectAllButton.on("click", function() {context.treeActionHandler(function() {
            context.selectorTree.selectAll();
            context.resetHideNotSelectedState();
        }, true, true)});

        this.clearButton.on("click", function() {context.treeActionHandler(function() {
            context.selectorTree.deselectAll();
            context.resetHideNotSelectedState()
           }, true, true)});

        this.expandAllButton.on("click", function() {context.treeActionHandler(
            function() {
                context.expandCollapseHandler(
                    function() {
                        context.selectorTree.expandAll();
                    })
            }, true, false)});
        this.collapseAllButton.on("click", function() {context.treeActionHandler(
            function() {
                context.expandCollapseHandler(
                    function() {
                        context.selectorTree.collapseAll();
                    })
            }, true, false)});

        this._toggleHideNonSelected = function() {context.treeActionHandler(function() {context.toggleHideNonSelectedButton()}, true, false)};

        this.hideNonSelectedButton.on("click", this._toggleHideNonSelected);

        this.hideNonSelectedButton.on("mouseover", function() {addClass(context.hideNonSelectedButton.el.dom.childNodes[0], "hovered")});
        this.hideNonSelectedButton.on("mouseout", function() {removeClass(context.hideNonSelectedButton.el.dom.childNodes[0], "hovered")});

        this.filterButton.on("click", function() {context.treeActionHandler(function() {context.showFilterWordsPopup()}, true, false)});

        this.hideNonSelectedButtonChecked = false;
    },

    createCustomControlButtons: function()
    {
        this.selectAllButton = this.createIconButton("doubleButton selectAllButton", "selector_panel/toolbar-button-icons-sprite.png");
        this.clearButton = this.createIconButton("doubleButton clearAllButton", "selector_panel/toolbar-button-icons-sprite.png");
        this.expandAllButton = this.createIconButton("doubleButton expandAllButton", "selector_panel/toolbar-button-icons-sprite.png");
        this.collapseAllButton = this.createIconButton("doubleButton collapseAllButton", "selector_panel/toolbar-button-icons-sprite.png");
        this.hideNonSelectedButton = this.createIconButton("hideNonSelectedButton", "selector_panel/toolbar-hide-not-selected.png",
                                                           "", messageResource.getMessage( "common.hierarchical_selector.hide_non_selected_button" ));
        this.filterButton = this.createIconButton("filterButton", "selector_panel/toolbar-filter.png");
    },

    resetState: function(isEnableActiveActions)
    {
        if (this.hideNonSelectedButtonChecked)
        {
            this._toggleHideNonSelected();
        }
        HierarchicalSelectorPanel.superclass.resetState.call(this, isEnableActiveActions);
    },

    createSelectionFilters: function()
    {
        HierarchicalSelectorPanel.superclass.createSelectionFilters.call(this);

        var context = this;
        this.showInactiveCheckbox.on("check", function(e, checked) {
            context.treeActionHandler(function() {
                context.selectorFilter.setShowInactiveAndReFilter(checked);
            }, true, context.selectionChangedOnShowInactive);
        });
    },

    toggleHideNonSelectedButton: function()
    {
        this.hideNonSelectedButtonChecked = !this.hideNonSelectedButtonChecked;
        //this code was add because IE doesn't recognize double classnames in css selectors
        if (this.hideNonSelectedButton.el){
            var el = $(this.hideNonSelectedButton.el.dom);
            el.toggleClass("active", this.hideNonSelectedButtonChecked);
            el.toggleClass("non-active", !this.hideNonSelectedButtonChecked);
        }
        this.selectorFilter.setShowSelectedOnlyAndReFilter(this.hideNonSelectedButtonChecked);
    },

    setHideNonSelectedButtonState: function(checked) {
        this.hideNonSelectedButtonChecked = !checked;
        this.toggleHideNonSelectedButton();
    },

    resetHideNotSelectedState: function() {
        this.selectorFilter.updateSelectedOnlyState();
        if(this.selectorFilter.isShowSelectedOnly())
            this.selectorFilter.reFilter();
        this.setHideNonSelectedButtonState(false);
    },

    afterResetAction: function() {
        this.resetHideNotSelectedState();
        if (this.filterWordsPopup && this.filterWordsPopup.isShown()) {
            this.filterWordsField.clearInputValue( true );
            this.filterWordsPopup.hide();
            this.updateState();
        }
    },

    defineSelectorTreeEvents: function() {
        //do nothing
    },

    disableTextSelectionForNeededElements: function() {
        disableTextSelection(this.customOptionsContainer.el.dom);
    },

    createIconButton: function(clazz, iconPath, linkCls, tooltip) {
        return new IconButton({
                                  cls: clazz,
                                  icon: atImgPath(iconPath),
                                  linkCls: (linkCls) ? linkCls : "",
                                  tooltip: ( tooltip ) ? tooltip : ""
                              });
    },

    onFilterFieldChanged: function ()
    {
        var context = this;
        this.treeActionHandler( function () {
                                    context.selectorFilter.setSearchStringAndReFilter( context.filterWordsField.getSearchString() );
                                },
                                true,
                                false );
    },

    showFilterWordsPopup: function(offset) {
        if (!this.selectorFilter) {
            return;
        }
        
        var context = this;
        this.selectorTree.expandAll();
        this.saveCollapsedNodesIntoCookies();
        if (!this.filterWordsPopup)
        {
            this.filterWordsField = new FilterWordsField().initAndRender( function () { context.onFilterFieldChanged(); }, null, null,
                                                                          function () { context.filterWordsField.clearInputValue(); context.onFilterFieldChanged(); });
            this.filterWordsPopup = new FilterWordsPopup().initAndRender(   "filterWordsPopup-" + this.id, this.filterButton.id,
                                                                            this.id, this.hasPanel, this.filterWordsField.getElement(),
                                                                            function () {
                                                                                context.filterWordsField.clearInputValue(true);

                                                                                // fix for bug 54553 (set focus to some focusable element in selector)
                                                                                if( context.customOption)
                                                                                {
                                                                                    $(context.customOption.innerWrap.dom).focus();
                                                                                }
                                                                            } );
        }
        this.onChange(); // call onChange to open panel with filterButton (bug 54534)
        var coordinates = this.getFilterWordsPopupCoordinates();
        this.filterWordsPopup.show(coordinates.x, coordinates.y);
        this.filterWordsField.activateAndFocus();
    },

    getFilterWordsPopupCoordinates : function ()
    {
        return {
            x : 2,
            y : -3
        }
    },

    showCallback: function() {
        var context = this;

        if (!this.isAlreadyShown()) {
            this.processFirstPanelOpen();
        } else {
            context.setHideNonSelectedButtonState(false);
        }
        if (context.hasPanel) {
            KeyDownHandler.setOnKeyDownHandler(function(event) {
                if (isLetterOrDigitSymbolPressed(event)) {
                    context.showFilterWordsPopup();
                }
            });
            this.canRemoveKeyHandler = true;
        }
    },

    buildSelectorTree: function() {
        this.selectorTree.getSelectionController().resetSelectedNodes();
        this.selectorTree.buildDOM(this.treePanel, this.selectorFilter);
        this.treePanel.className = this.getTreePanelClasses().join(" ");
        this.setAlreadyShown();
        this.updateState();
        this.disableTextSelectionForNeededElements();
        this.fireSelectionChangeAllowed = true;
    },

    getTreePanelClasses: function()
    {
        var classes = ["treePanel"];
        if (this.customOption && !this.customOption.getValue())
            classes.push("inactiveTree");
        return classes;
    },

    processFirstPanelOpen: function() {
        if (!this.treePanel) {
            this.treePanel = document.createElement("div");
            var treePanelClasses = this.getTreePanelClasses();
            treePanelClasses.push("spinnerPanel"); // spin while panel is not loaded
            this.treePanel.className = treePanelClasses.join(" ");
            var targetEl = this.detailsContainer.el.dom;
            var firstChild = targetEl.childNodes[0];
            if (firstChild) {
                targetEl.insertBefore(this.treePanel, firstChild);
            } else {
                targetEl.appendChild(this.treePanel);
            }
        }
    },

    getCustomOptionSection: function() {
        //from left to right
        var buttons = [];
        buttons.push(this.customOption);
        buttons.push(this.filterButton, this.makeVerticalSeparator());
        buttons.push(this.hideNonSelectedButton, this.makeVerticalSeparator());
        buttons.push(this.selectAllButton, this.makeVerticalSeparator());
        buttons.push(this.clearButton);
        if (this.canExpandCollapseNodes())
        {
            buttons.push(this.makeVerticalSeparator(), this.collapseAllButton, this.expandAllButton);
        }
        return buttons.reverse(); // reverse because float:right property are used
    },

    getBaseUserSelectorPanelCustomOptionFields: function() {
        var fields = [ this.filterButton, this.hideNonSelectedButton, this.makeVerticalSeparator()];
        if (this.canExpandCollapseNodes()) {
            fields = fields.concat([this.collapseAllButton, this.expandAllButton, this.makeVerticalSeparator()]);
        }
        return fields;
    },

    filterTreeNodes: function(showInactive) {
        //do nothing
    },

    saveCollapsedNodesIntoCookies: function() {
        //abstract
    },

    getCollapsedNodeIdsFromCookies: function()
    {
        return this.canExpandCollapseNodes() ? getArrayFromCookies(this.collapsedCookiesKey) : [];
    },

    canExpandCollapseNodes: function() {
        //abstract
    },

    getNodeRenderers: function() {
        //abstract
    },

    createTree: function() {
        //abstract
    },

    isTopNodeLevel: function(treeNode) {
        //abstract
    },

    isLowNodeLevel: function(treeNode) {
        //abstract
    },

    isHiddenNodeSelected: function(treeNode) {
        //abstract
    },

    createEmptyMessageBuilder: function() {
        //abstract
    },

    makeSelectionHelper: function() {
        //abstract
    },

    getSelection: function(isFullFormed) {
        //abstract
    },

    makeNodeSet: function(selection) {
        //abstract
    },

    isInnerTooltipsEnabled: function() {
        if (this.isCustomOptionSelected()) {
            var selection = this.getSelection(false);
            return (selection.getFirstLevel().length != 0) && (selection.getSecondLevel().length != 0);
        }
        return false;
    },

    isTooltipEnabled: function(){
        if (this.isCustomOptionSelected()) {
            var selection = this.getSelection(false);
            return !selection.isEmpty();
        }
        return false;
    },

    isActiveActionsPermitted: function() {
        return this.isAlreadyShown();
    },

    clearSelection: function() {
        this.selectorTree.deselectAll();
    },

    checkHiddenNodeSelectionTemplate: function(treeNode, checkFunction) {
        return this.isLowNodeLevel(treeNode) && checkFunction(treeNode) &&
               this.selectorTree.hasActiveFilter() && this.selectorTree.getActiveFilter().getResults().contains( treeNode );
    },

    getSelectedNodeSet: function() {
        return (this.isAlreadyShown()) ? this.selectorTree.getSelectionController().getSelectedNodeSet() :
               this.selectorTree.getSelectionController().getInitiallySelectedNodeSet();
    },

    getDescription: function(selectionHelper, dropdownButtonId) {
        return selectionHelper.getDescription(this.getSelection(true), dropdownButtonId, true);
    },

    getPartialTooltipText : function(isForTopLevelEntity) {
        if (this.currentOption != this.customOption) {
            return this.currentOption.boxLabel;
        } else {
            return this.getTooltipForCustomPartialOption(isForTopLevelEntity);
        }
    },

    getTooltipForCustomOption: function() {
        return this.getSelectionHelper().getOneOfEntitiesList(this.getSelection(true));
    },

    getTooltipForCustomPartialOption: function(isForTopLevelEntity) {
        return this.getSelectionHelper().getCertainEntityList(this.getSelection(true), isForTopLevelEntity);
    },

    /**
     * Returns the selection which represents Select All custom option
     */
    getLowLevelEntities: function() {
        return this.selectorTree.getLowLevelEntities(this.getFilterCallback());
    },

    getFilterCallback: function() {
        return function(entity) {
            return true;
        }
    },

    setSelectorFilter: function() {
        this.selectorFilter = new SelectorFilter( this.selectorTree, this.searchIndex, this.allActiveSet );
    },

    createSelectorTree: function() {
        this.selectorTree = this.createTree();
        this.setSelectorFilter();
        var context = this;
        this.selectorTree.getSelectionController().addListener( {
                                                                    nodeDeselected: function() {context.treeActionHandler(function(){}, true, true)},
                                                                    nodeSelected: function( treeNode ) {
                                                                        context.treeActionHandler(function() {
                                                                            if( context.isTopNodeLevel(treeNode) && context.selectorTree.hasActiveFilter() &&
                                                                                context.selectorTree.getActiveFilter().isShowSelectedOnly())
                                                                            {
                                                                                context.selectorFilter.updateSelectedOnlyState();
                                                                            }
                                                                            else
                                                                            {
                                                                                context.checkAndProcessHiddenNodeSelection(treeNode);
                                                                            }
                                                                        }, true, true)
                                                                    }} );

        this.selectorTree.setNodeRenderers(this.getNodeRenderers());
    },

    checkAndProcessHiddenNodeSelection: function(treeNode) {
        if (this.isHiddenNodeSelected(treeNode)) {
            this.showInactiveCheckbox.setChecked(true);
            this.selectorFilter.setShowInactiveAndReFilter(true);
        }
    },

    isSelectionChanged: function() {
        return (this.showInactive != this.getShowInactive()) || this.selectorTree.isSelectionChanged();
    },

    isTruncateStrings: function() {
        //all strings truncation is performed in css
        return false;
    },

    onGenericOptionSelect: function(option, checked) {
        if (checked) {
            var self = this;
            this.treeActionHandler(function() {
                $(self.treePanel).addClass("inactiveTree");
                // close filter popup if open
                if( self.filterWordsPopup && self.filterWordsPopup.isShown() ) {
                    self.filterWordsField.clearInputValue();
                    self.filterWordsPopup.hideWithoutCallback();
                    self.selectorFilter.setSearchStringAndReFilter( self.filterWordsField.getSearchString() );
                }
            }, false, true);
        }
    },

    onCustomOptionSelect: function(option, checked) {
        if (checked) {
            var self = this;
            this.treeActionHandler(function() {
                $(self.treePanel).removeClass("inactiveTree");
            }, false, true);
        }
    },

    markPredefinedNodesAsSelected: function(selection) {
        this.selectorTree.getSelectionController().initializeByNodeSet(this.makeNodeSet(selection));
    },

    selectNodes: function(selection) {
        this.selectorTree.resetNodes( this.makeNodeSet( selection ) );
    },

    setSelection: function(selection) {
        if (!this.isAlreadyShown()) {
            this.markPredefinedNodesAsSelected(selection);
        } else {
            this.selectNodes(selection);
        }
        this.fireChangeEvent();
    },

    setPredefinedParameters: function(state) {
        this.showInactive = state.showInactive;
        this.setInitialOptionValue(state.optionValue);
        this.markPredefinedNodesAsSelected(state.selection);
    },

    loadState: function(state)
    {
        this.setInitialOptionValue(this.getOptionValueByStateValue(state.optionValue));
        this.showInactive = state.showInactive;
        this.loadPermanentState(state);
        this.setSelection(state.selection);
        this.updateState();
    },

    getOptionValueByStateValue: function(stateValue) {
        return (stateValue) ? this.allItemsOptionValue : this.customOptionValue;
    },

    getStateValueByOptionValue: function(optionValue) {
        return (optionValue == this.allItemsOptionValue);
    },

    getState: function()
    {
        return {
            showInactive: this.getShowInactive(),
            optionValue: this.getStateValueByOptionValue(this.getCurrentOptionValue()),
            selection: this.getSelection()
        }

    },

    loadPermanentState: function(state) {
        if (state.selectionHelper) {
            this.selectionHelper = state.selectionHelper;
        } else {
            this.makeSelectionHelper();
        }
    },

    createDefaultState: function ()
    {
        return   {
            showInactive: false,
            optionValue: this.allItemsOptionValue,
            selection: TwoLevelSelection.emptySelection()
        };
    },

    /**
     * Returns true if panel can be hidden and false otherwise
     */
    processHide:function () {
        var isPermitted = true;
        if( this.filterWordsPopup && this.filterWordsPopup.isShown() ) {
            isPermitted = !this.filterWordsPopup.isHideByEscape( window.event );
            this.filterWordsField.clearInputValue( true );
            this.filterWordsPopup.hide();
        }
        if( isPermitted && this.hasPanel && this.canRemoveKeyHandler ) {
            this.canRemoveKeyHandler = false;
            KeyDownHandler.restoreOnKeyDownHandler();
        }
        return isPermitted;
    },

    treeActionHandler : function(f, isFirePanelChange, isFireSelectionChange) {
        f();
        if (isFirePanelChange) {
            this.onChange();
        }
        if (this.selectionChangedHandler && isFireSelectionChange && this.fireSelectionChangeAllowed) {
            this.selectionChangedHandler();
        }
    },

    expandCollapseHandler : function(f) {
        f();
        this.saveCollapsedNodesIntoCookies();
    },

    getExpandCollapseCallback: function() {
        var context = this;
        return function(f){
            context.treeActionHandler(
                function() {
                    context.expandCollapseHandler(f);
                }, true, false
            );
        }
    },

    isEmptySelection: function() {
        return this.getSelection(false).isEmpty();
    },

    clearPanel: function(){
        if (this.treePanel)
        {
            this.treePanel.remove();
            this.treePanel = undefined;
        }
    }
});

Ext.reg("at_hierarchical_selector_panel", HierarchicalSelectorPanel);

export default HierarchicalSelectorPanel;


// WEBPACK FOOTER //
// ./web/js/controls/selectorControls/at_hierarchical_selector_panel.js